import { IKnmNoticeType } from 'APIPackage/CatalogsModule/interfaces/IKnmNoticeType';

import { IKnmNotificationMethodSelectOption } from '../interfaces/IKnmNotificationMethodSelectOption';

export const createKnmNotificationMethodSelectOption = (
  knmNotificationType: IKnmNoticeType,
): IKnmNotificationMethodSelectOption => ({
  ...knmNotificationType,
  label: knmNotificationType.name,
  value: knmNotificationType.code,
});
